// extracted by mini-css-extract-plugin
export default {"nav":"_FPgX"};